import React from 'react';
import { Field, FieldProps } from 'formik';
import Toggle, { ToggleProps } from 'react-toggle';

export interface FormikToggleProps extends ToggleProps {}

const FormikToggle: React.FC<FormikToggleProps> = ({ name, ...others }) => {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <Toggle
          onChange={() => form.setFieldValue(field.name, !field.value)}
          {...others}
          checked={field.value}
        />
      )}
    </Field>
  );
};

export default FormikToggle;
